export default {
  name: 'currencies',
}
